class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    const gridWrapperFilter = document.querySelector('#product-grid');

    const cardAtcBtnFilter = () => {

      gridWrapperFilter.querySelectorAll('.card-wrapper-box').forEach( (quickCartContainer) => {
        if ( quickCartContainer.querySelector('.bt-qatc-btn-container')) {
          quickCartContainer.querySelector('.bt-qatc-btn-container').addEventListener('click', (evt) => {
            quickCartContainer.querySelector('.bt-qatc-container').addEventListener('click', () => {
              quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove ('is-visible');
            });
            quickCartContainer.querySelector('.bt-qatc-container').classList.add('is-visible');
            quickCartContainer.querySelector('.bt-qatc-form-container').classList.add('is-visible');
            const atcFormFilter = quickCartContainer.querySelector('.bt-qatc-form');
            atcFormFilter.addEventListener('input', (e) => {
              e.preventDefault();
              atcFormApiFilter(atcFormFilter);
              atcFormFilter.reset();
              quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
            });
          });
        }
      });
    }

    async function atcFormApiFilter(form) {
      try {
        const cartSections = document.querySelector('cart-notification, cart-drawer');
        const formData = new FormData(form);
        if (cartSections) {
          formData.append('sections', Array.from(cartSections.getSectionsToRender(), section => section.id));
        }

        formData.append('sections_url', window.location.pathname)
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!resp.ok) {
          throw new Error("Error While adding to cart")
        }

        const data = await resp.json();

        if (cartSections) {
          cartSections.renderContents(data);
        }
      } catch (error) {
        console.log("Quick add to cart error!!!", error)
      }
    }

    const variantListCloseFilter = () => {
      gridWrapperFilter.querySelectorAll('.grid__item').forEach( productCard => {
        productCard.addEventListener('mouseleave', () => {
          if (productCard.querySelector('.bt-qatc-form-container')) {
            productCard.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
          }
        });
      });
    }

    const cardSliderFilter = () => {
      let gridItems = gridWrapperFilter.querySelectorAll('.grid__item');
      gridItems.forEach( item => {
        var swiper = new Swiper(item.querySelector('.card_carousel'), {
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          }
        });
      });
    }

    const productSizechartFilter = (sizeChartContainer) => {
      if (sizeChartContainer.querySelector('#cm2') && sizeChartContainer.querySelector('#inches2') && sizeChartContainer.querySelector('table')) {

        function inchesToCentimeters(inches) {
          return inches * 2.54;
        }

        function centimetersToInches(cm) {
          return cm / 2.54;
        }

        function toggleUnit(unit) {
          let sizeCells = sizeChartContainer.querySelectorAll('td:not(.sc__item)');
          sizeCells.forEach(function(cell) {
            let originalValue = parseFloat(cell.getAttribute('data-original-value'));
            if (!isNaN(originalValue)) {
              if (unit === 'cm') {
                let cm = inchesToCentimeters(originalValue);
                cell.textContent = cm.toFixed(2);
              } else if (unit === 'inches') {
                let inches = originalValue;
                cell.textContent = inches.toFixed(2);
              }
            } else {
              cell.textContent = '-';
            }
          });

          if (unit === 'inches') {
            sizeChartContainer.querySelector('#inches2').classList.add('active');
            sizeChartContainer.querySelector('#cm2').classList.remove('active');
          } else if (unit === 'cm') {
            sizeChartContainer.querySelector('#cm2').classList.add('active');
            sizeChartContainer.querySelector('#inches2').classList.remove('active');
          }
        }

        function storeOriginalValues() {
          let sizeCells = sizeChartContainer.querySelectorAll('table td');
          sizeCells.forEach(function(cell) {
            let value = parseFloat(cell.textContent);
            if (!isNaN(value)) {
              cell.setAttribute('data-original-value', value);
            } else {
              cell.setAttribute('data-original-value', '-');
            }
          });
        }

        storeOriginalValues();

        let selectedUnit = 'inches';
        toggleUnit(selectedUnit);

        sizeChartContainer.querySelector('#cm2').addEventListener('click', function() {
          selectedUnit = 'cm';
          toggleUnit(selectedUnit);
        });

        sizeChartContainer.querySelector('#inches2').addEventListener('click', function() {
          selectedUnit = 'inches';
          toggleUnit(selectedUnit);
        });
      }
    }

    const sizeChartCloseBtnFilter = (sizeChartContainer) => {
      sizeChartContainer.querySelector('.bt-sc-close-btn,.bt-sc-overlay').addEventListener('click', () => {
        document.querySelector('.bt-sc-overlay').removeAttribute('style');
        sizeChartContainer.removeAttribute('style');
        sizeChartContainer.querySelector('.bt-sc-items-container').innerHTML = null;
        sizeChartContainer.querySelector('img').src = '';
      });

      document.querySelector('.bt-sc-overlay').addEventListener('click', () => {
        document.querySelector('.bt-sc-overlay').removeAttribute('style');
        sizeChartContainer.removeAttribute('style');
        sizeChartContainer.querySelector('.bt-sc-items-container').innerHTML = null;
        sizeChartContainer.querySelector('img').src = '';
      });
    
    }

    const sizeChartBtnFilter = () => {
      gridWrapperFilter.querySelectorAll('.bt-qatc-measurement-input').forEach(scBtn => {
        scBtn.addEventListener('click', (evt) => {
          document.querySelector('#bt-sc-overlay').style.display = 'block';
          const sizeChartContainer = document.querySelector('#bt-sc-container');
          sizeChartContainer.style.transform = 'translateX(0px)';
          sizeChartContainer.querySelector('.bt-sc-title h2').innerText = evt.target.dataset.scTitle;
          sizeChartContainer.querySelector('.bt-sc-media img').src = evt.target.dataset.scImg;
          let cloneSc = evt.target.nextElementSibling.cloneNode(true);
          sizeChartContainer.querySelector('.bt-sc-items-container').append(cloneSc)
          sizeChartContainer.querySelector('.bt-sc-items-container .bt-qatc-collection-chart').style.display = 'block';

          sizeChartCloseBtnFilter(sizeChartContainer);
          productSizechartFilter(sizeChartContainer);
        });
      });
    }
    const filterLayoutToggleBtnFilter = () => {
      const toggleBtn = document.querySelector('.toggle-layout-btn');
      const layout = document.querySelector('#product-grid');
  
      toggleBtn.addEventListener('click', () => {
        toggleBtn.classList.toggle('active');
        layout.classList.toggle('grid--4-col-desktop');
        layout.classList.toggle('grid--2-col-desktop');
      });
  
    };

    cardSliderFilter();
    cardAtcBtnFilter();
    variantListCloseFilter();
    sizeChartBtnFilter();
    filterLayoutToggleBtnFilter();

    if (typeof Ajaxinate !== 'undefined' && gridWrapperFilter) {
      const endlessScrollFilter = new Ajaxinate({
        container: '#product-grid',
        pagination: '#AjaxinatePagination',
        loadingText: 'Loading more...',
        method: "scroll",
        callback: function() {
          cardSliderFilter();
          cardAtcBtnFilter();
          variantListCloseFilter();
          sizeChartBtnFilter();
        }
      });
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    document.querySelectorAll('.facets__selected-container').forEach( closeFilterBtn => {
      closeFilterBtn.addEventListener('click', () => {
        document.querySelector('.disclosure-has-popup[open]').removeAttribute('open');
      });
    });

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);

    return endlessScroll
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('DOMContentLoaded', function() {
  var filterOptions = document.querySelectorAll('.custom-filters-option .facets__summary');
  filterOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      var value = this.getAttribute('data-value');
      var mainEl = document.querySelector('[data-main-filter-option="' + value + '"]');
      mainEl.click();
      if (mainEl) {
        var parentEl = mainEl.parentElement;
        if (parentEl) {
          var grandParentEl = parentEl.parentElement;
          var parentSiblings = Array.prototype.filter.call(grandParentEl.children, function(child) {
            return child !== parentEl;
          });
          parentSiblings.forEach(function(sibling) {
            sibling.removeAttribute('open');
          });
        }
      }
    });
  });
});

  document.querySelectorAll('.facets__selected-container').forEach( closeFilterBtn => {
    closeFilterBtn.addEventListener('click', () => {
      document.querySelector('.disclosure-has-popup[open]').removeAttribute('open');
    });
  });
